<header class="navbar-header">
  <nav class="navbar fixed-top px-3 py-2" style="background-color: #f8fdfe; color: #203b72; border-bottom: #203b72 1px solid;">
    <div class="container-fluid ">
      <a class="navbar-brand d-flex align-items-center mb-2 mb-md-0" routerLink="/">
        <img class="log-img" src="../../assets/images/AppIcon1.png" >
        <span class="brand-title">CloRent Factory</span>
      </a>
      <div class="d-flex align-items-center gap-2">
        <img class="app-logo" src="../../assets/images/android.png" alt="Android" (click)="openPlaystoreAgent()">
        <img class="app-logo" src="../../assets/images/apple.png" alt="Apple" (click)="openAppstoreAgent()">
      </div>
    </div>
  </nav>
</header>

